import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import EmbeddedNotesSection from './EmbeddedNotesSection';

const NotesTab = ({ organization, onNotesUpdate }) => {
  if (!organization) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography color="text.secondary">
          No organization selected
        </Typography>
      </Box>
    );
  }
  
  return (
    <Card variant="outlined">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DescriptionIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6">
              Organisation Notes
            </Typography>
          </Box>
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        <EmbeddedNotesSection
          organizationId={organization.id}
          initialNotes={organization.notes}
          onNotesUpdate={onNotesUpdate}
          title=""
          compact={false}
        />
      </CardContent>
    </Card>
  );
};

export default NotesTab; 